import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/audicus-logo-white.png';
import samsClubLogo from '../assets/images/sams-club-logo-white.png';
import blurred from '../assets/images/soundwaves-blur.png';

import { useTranslation } from 'react-i18next';
import useTracking from '../hooks/useTracking';

const Home = ({
  rht,
  isB2b,
  isB2b2c,
}: {
  rht: boolean;
  isB2b: boolean;
  isB2b2c: boolean;
}) => {
  const { trackEvent } = useTracking();
  const { t, i18n } = useTranslation('home');

  useEffect(() => trackEvent('JHT_VIEW_LANDING'), [trackEvent]);

  const toggleLanguage = () => {
    const newLanguage = i18n.language === 'en' ? 'es' : 'en';
    i18n.changeLanguage(newLanguage);
  };

  const versionId = process.env.REACT_APP_VERSION
    ? `${process.env.REACT_APP_VERSION}-${i18n.language}-${rht ? 'rht' : 'jht'}`
    : process.env.REACT_APP_GIT_COMMIT
      ? `${process.env.REACT_APP_GIT_COMMIT}-${i18n.language}-${rht ? 'rht' : 'jht'}`
      : `dev-${i18n.language}-${rht ? 'rht' : 'jht'}`;
  // console.log('versionId:', versionId)

  return (
    <div className="home">
      <div className="main-content">
        <div className="version-container">
          <p style={{ color: 'white', fontSize: '2px' }}> {versionId} </p>
        </div>

        <div className="home-language-button">
          <button onClick={toggleLanguage}>
            {i18n.language === 'en' ? 'Español' : 'English'}
          </button>
        </div>

        {/* ZMTODO: Add language button for home screen in upper corner */}

        {rht ? (
          <img
            className="sams-club-logo-white"
            src={samsClubLogo}
            alt="audicus logo"
            style={{ paddingBottom: 20 }}
          />
        ) : null}

        <img className="audicus-logo-white" src={logo} alt="audicus logo" />
        <div className="title-container">
          <h1>{t('hearing')}</h1>
          <h1>{t('test')}</h1>
        </div>
        <div className="description">
          <p>{t('title')}</p>
          <p style={{ color: 'white' }}>{t('subtitle')}</p>
        </div>

        {/* instructions for b2b2c */}
        {isB2b2c ? (
          <div className="test-instructions">
            <p className="instruction-title">{t('instructions-title')}</p>
            <p className="instruction">{t('instruction-1')}</p>
            <p className="instruction">{t('instruction-2')}</p>
            <p className="instruction">{t('instruction-3')}</p>
            <p className="instruction">{t('instruction-4')}</p>
          </div>
        ) : null}

        <Link
          // to={rht ? '/earhistory' : '/demographics'}
          to={'/demographics'}
          className="link-button"
        >
          {t('button-text')}
        </Link>

        <div style={{ marginTop: 20, marginBottom: 20 }}>
          {!isB2b && !rht ? (
            <a
              href="https://audicus.com/submit-test"
              className="already-tested"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'white' }}
            >
              {t('already-tested')}
            </a>
          ) : null}
          {/* )} */}
        </div>
      </div>
      <img className="soundwaves" src={blurred} alt="soundwaves background" />
    </div>
  );
};

export default Home;
